import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import { Credentials } from '@wizbii-utils/angular/algolia';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlgoliaCredentialsService {
  private readonly http = inject(HttpClient);

  getCredentialsFromAccount(): Observable<Credentials> {
    return this.http.get<Credentials>(`${environment.api.account}/_credentials/algolia`);
  }
}
